var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g2, _path11, _path12, _path13, _path14, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificateNotFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 86,
    viewBox: "0 0 103 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6672 43.3037C86.6672 50.8023 84.4436 58.1324 80.2776 64.3673C76.1116 70.6021 70.1903 75.4616 63.2625 78.3312C56.3347 81.2008 48.7116 81.9516 41.3571 80.4887C34.0026 79.0258 27.247 75.4149 21.9447 70.1126C16.6424 64.8103 13.0315 58.0547 11.5686 50.7002C10.1057 43.3457 10.8565 35.7226 13.7261 28.7948C16.5957 21.867 21.4552 15.9457 27.69 11.7797C33.9249 7.61373 41.255 5.39014 48.7536 5.39014C58.8089 5.39014 68.4524 9.38459 75.5625 16.4948C82.6727 23.6049 86.6672 33.2484 86.6672 43.3037Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5906 37.7091C22.5906 36.1298 23.8591 34.8496 25.4238 34.8496H71.3936C72.9584 34.8496 74.2269 36.1298 74.2269 37.7091V51.7936C74.2269 53.3729 72.9584 54.6531 71.3936 54.6531H25.4238C23.8591 54.6531 22.5906 53.3729 22.5906 51.7937V37.7091Z",
    fill: "#00C7C8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6887 38.4975C25.6887 37.6341 26.3823 36.9341 27.2378 36.9341H38.5978C39.4533 36.9341 40.1469 37.6341 40.1469 38.4975V38.4975C40.1469 39.361 39.4533 40.0609 38.5978 40.0609H27.2378C26.3823 40.0609 25.6887 39.361 25.6887 38.4975V38.4975Z",
    fill: "#D9FBF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6887 47.8781C25.6887 47.5903 25.9199 47.3569 26.2051 47.3569H62.3505C62.6357 47.3569 62.8669 47.5903 62.8669 47.8781V47.8781C62.8669 48.1659 62.6357 48.3992 62.3505 48.3992H26.2051C25.9199 48.3992 25.6887 48.1659 25.6887 47.8781V47.8781Z",
    fill: "#D9FBF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6887 49.9626C25.6887 49.6747 25.9199 49.4414 26.2051 49.4414H29.3033C29.5884 49.4414 29.8196 49.6747 29.8196 49.9626V49.9626C29.8196 50.2504 29.5884 50.4837 29.3033 50.4837H26.2051C25.9199 50.4837 25.6887 50.2504 25.6887 49.9626V49.9626Z",
    fill: "#D9FBF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8853 49.9626C31.8853 49.6747 32.1164 49.4414 32.4016 49.4414H35.4998C35.785 49.4414 36.0162 49.6747 36.0162 49.9626V49.9626C36.0162 50.2504 35.785 50.4837 35.4998 50.4837H32.4016C32.1164 50.4837 31.8853 50.2504 31.8853 49.9626V49.9626Z",
    fill: "#D9FBF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0815 49.9626C38.0815 49.6747 38.3127 49.4414 38.5979 49.4414H41.6961C41.9813 49.4414 42.2125 49.6747 42.2125 49.9626V49.9626C42.2125 50.2504 41.9813 50.4837 41.6961 50.4837H38.5979C38.3127 50.4837 38.0815 50.2504 38.0815 49.9626V49.9626Z",
    fill: "#D9FBF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2778 49.9626C44.2778 49.6747 44.509 49.4414 44.7942 49.4414H47.8924C48.1776 49.4414 48.4087 49.6747 48.4087 49.9626V49.9626C48.4087 50.2504 48.1775 50.4837 47.8924 50.4837H44.7942C44.509 50.4837 44.2778 50.2504 44.2778 49.9626V49.9626Z",
    fill: "#D9FBF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4741 49.9626C50.4741 49.6747 50.7053 49.4414 50.9905 49.4414H54.0887C54.3738 49.4414 54.605 49.6747 54.605 49.9626V49.9626C54.605 50.2504 54.3738 50.4837 54.0887 50.4837H50.9905C50.7053 50.4837 50.4741 50.2504 50.4741 49.9626V49.9626Z",
    fill: "#D9FBF9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9978 37.4552C66.9978 37.1674 67.229 36.9341 67.5142 36.9341H70.6123C70.8975 36.9341 71.1287 37.1674 71.1287 37.4552V37.4552C71.1287 37.743 70.8975 37.9764 70.6123 37.9764H67.5142C67.229 37.9764 66.9978 37.743 66.9978 37.4552V37.4552Z",
    fill: "#D9FBF9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9651 51.0053C65.9651 50.1419 66.6586 49.4419 67.5142 49.4419H69.5796C70.4352 49.4419 71.1287 50.1419 71.1287 51.0053V51.0053C71.1287 51.8688 70.4352 52.5688 69.5796 52.5688H67.5142C66.6586 52.5688 65.9651 51.8688 65.9651 51.0053V51.0053Z",
    fill: "#D9FBF9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6887 42.6665C25.6887 41.803 26.3823 41.103 27.2378 41.103H52.0232C52.8788 41.103 53.5723 41.803 53.5723 42.6665V42.6665C53.5723 43.5299 52.8788 44.2299 52.0232 44.2299H27.2378C26.3823 44.2299 25.6887 43.5299 25.6887 42.6665V42.6665Z",
    fill: "#D9FBF9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8015 37.4552C60.8015 37.1674 61.0327 36.9341 61.3179 36.9341H64.4161C64.7012 36.9341 64.9324 37.1674 64.9324 37.4552V37.4552C64.9324 37.743 64.7012 37.9764 64.4161 37.9764H61.3179C61.0327 37.9764 60.8015 37.743 60.8015 37.4552V37.4552Z",
    fill: "#D9FBF9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2549 66.1553L82.8069 63.6033L88.8689 69.6653L86.3169 72.2173L80.2549 66.1553Z",
    fill: "#005370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.172 44.5023C59.0654 46.6103 57.631 49.2956 57.0502 52.2188C56.4694 55.142 56.7682 58.1718 57.9089 60.9252C59.0496 63.6785 60.981 66.0318 63.4588 67.6875C65.9366 69.3431 68.8496 70.2268 71.8295 70.2268C74.8094 70.2268 77.7224 69.3431 80.2002 67.6875C82.678 66.0318 84.6093 63.6785 85.75 60.9252C86.8907 58.1718 87.1895 55.142 86.6087 52.2188C86.0279 49.2956 84.5935 46.6103 82.4869 44.5023C79.6594 41.6772 75.8262 40.0903 71.8295 40.0903C67.8328 40.0903 63.9995 41.6772 61.172 44.5023V44.5023ZM80.4577 63.7911C78.7515 65.4964 76.578 66.6574 74.2121 67.1274C71.8462 67.5974 69.3941 67.3553 67.1658 66.4317C64.9374 65.5081 63.0329 63.9444 61.693 61.9383C60.3531 59.9323 59.6379 57.5739 59.6379 55.1614C59.6379 52.7489 60.3531 50.3906 61.693 48.3846C63.0329 46.3785 64.9374 44.8148 67.1658 43.8912C69.3941 42.9676 71.8462 42.7255 74.2121 43.1955C76.578 43.6655 78.7515 44.8265 80.4577 46.5318C81.5914 47.6648 82.4906 49.0101 83.1042 50.4908C83.7177 51.9715 84.0335 53.5586 84.0335 55.1614C84.0335 56.7643 83.7177 58.3514 83.1042 59.8321C82.4906 61.3128 81.5914 62.6581 80.4577 63.7911Z",
    fill: "#005370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5142 70.1924L94.294 81.9723C94.8747 82.5297 95.6507 82.8373 96.4556 82.8291C97.2605 82.8209 98.0301 82.4975 98.5992 81.9283C99.1684 81.3592 99.4918 80.5896 99.5 79.7847C99.5082 78.9798 99.2006 78.2038 98.6432 77.6231L86.8633 65.8433L82.5142 70.1924Z",
    fill: "#005370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2005 65.2472L81.9272 70.5244C81.8533 70.597 81.7945 70.6834 81.7542 70.7789C81.7138 70.8743 81.6928 70.9768 81.6922 71.0804C81.6915 71.184 81.7114 71.2867 81.7506 71.3826C81.7898 71.4785 81.8476 71.5656 81.9206 71.6391C81.9937 71.7125 82.0805 71.7708 82.1761 71.8106C82.2717 71.8503 82.3742 71.8707 82.4777 71.8707C82.5813 71.8706 82.6838 71.8501 82.7793 71.8102C82.8749 71.7703 82.9617 71.712 83.0346 71.6384L88.3079 66.3613C88.3818 66.2892 88.4405 66.203 88.4806 66.1078C88.5207 66.0127 88.5413 65.9105 88.5413 65.8072C88.5413 65.7039 88.5207 65.6017 88.4806 65.5065C88.4405 65.4114 88.3818 65.3252 88.3079 65.2531C88.1616 65.1059 87.9629 65.0226 87.7554 65.0215C87.5479 65.0204 87.3484 65.1015 87.2005 65.2472V65.2472Z",
    fill: "#005370"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0247 65.0342L80.68 62.3788L86.9875 68.6863L84.3322 71.3417L78.0247 65.0342Z",
    fill: "#ADB5BD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1685 42.5042C55.9766 44.6976 54.4841 47.4917 53.8798 50.5333C53.2755 53.5749 53.5864 56.7274 54.7733 59.5923C55.9602 62.4572 57.9698 64.9057 60.5479 66.6284C63.1261 68.3512 66.157 69.2706 69.2576 69.2706C72.3582 69.2706 75.3892 68.3512 77.9673 66.6284C80.5455 64.9057 82.5551 62.4572 83.742 59.5923C84.9289 56.7274 85.2398 53.5749 84.6355 50.5333C84.0311 47.4917 82.5386 44.6976 80.3467 42.5042C77.4047 39.5647 73.4162 37.9136 69.2576 37.9136C65.0991 37.9136 61.1106 39.5647 58.1685 42.5042V42.5042ZM78.2354 62.5742C76.46 64.3486 74.1985 65.5567 71.7368 66.0457C69.2751 66.5348 66.7236 66.2828 64.405 65.3218C62.0864 64.3608 60.1048 62.7338 58.7106 60.6465C57.3164 58.5592 56.5723 56.1053 56.5723 53.5951C56.5723 51.0849 57.3164 48.631 58.7106 46.5437C60.1048 44.4564 62.0864 42.8294 64.405 41.8684C66.7236 40.9074 69.2751 40.6554 71.7368 41.1445C74.1985 41.6335 76.46 42.8416 78.2354 44.6159C79.4149 45.7948 80.3506 47.1946 80.989 48.7352C81.6274 50.2759 81.956 51.9273 81.956 53.5951C81.956 55.2628 81.6274 56.9143 80.989 58.4549C80.3506 59.9956 79.4149 61.3954 78.2354 62.5742Z",
    fill: "url(#paint1_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3752 69.2348L92.6322 81.4917C93.2364 82.0717 94.0438 82.3918 94.8813 82.3833C95.7188 82.3747 96.5196 82.0383 97.1118 81.446C97.704 80.8538 98.0405 80.053 98.0491 79.2156C98.0576 78.3781 97.7375 77.5706 97.1575 76.9664L84.9005 64.7095L80.3752 69.2348Z",
    fill: "url(#paint2_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2513 64.0894L79.7643 69.5802C79.6875 69.6558 79.6263 69.7458 79.5843 69.8451C79.5424 69.9443 79.5204 70.051 79.5198 70.1588C79.5192 70.2666 79.5398 70.3734 79.5806 70.4732C79.6214 70.573 79.6816 70.6637 79.7575 70.7401C79.8335 70.8165 79.9238 70.8772 80.0233 70.9185C80.1228 70.9599 80.2295 70.9812 80.3372 70.9811C80.4449 70.981 80.5516 70.9596 80.651 70.9182C80.7504 70.8767 80.8407 70.816 80.9166 70.7394L86.4035 65.2486C86.4804 65.1735 86.5415 65.0839 86.5832 64.9849C86.6249 64.8858 86.6464 64.7795 86.6464 64.672C86.6464 64.5646 86.6249 64.4582 86.5832 64.3592C86.5415 64.2602 86.4804 64.1705 86.4035 64.0955C86.2512 63.9423 86.0445 63.8556 85.8286 63.8545C85.6127 63.8534 85.4051 63.9378 85.2513 64.0894V64.0894Z",
    fill: "url(#paint3_linear)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.2576,
    cy: 53.592,
    r: 12.8279,
    fill: "#F1F7FF",
    fillOpacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.94678,
    y: 80.5098,
    width: 17.3466,
    height: 4.89935,
    rx: 2.44967,
    transform: "rotate(-45 3.94678 80.5098)",
    fill: "url(#paint4_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 53.8467,
    width: 6.93524,
    height: 4.89935,
    rx: 2.44967,
    transform: "rotate(-45 0.5 53.8467)",
    fill: "url(#paint5_linear)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.32544,
    y: 66.0337,
    width: 37.0195,
    height: 4.89935,
    rx: 2.44967,
    transform: "rotate(-45 5.32544 66.0337)",
    fill: "url(#paint6_linear)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5879,
    y: 36.6172,
    width: 24.4884,
    height: 4.89935,
    rx: 2.44967,
    transform: "rotate(-45 70.5879 36.6172)",
    fill: "url(#paint7_linear)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72.1912,
    y: 4.90381,
    width: 6.93524,
    height: 4.89935,
    rx: 2.44967,
    transform: "rotate(-45 72.1912 4.90381)",
    fill: "url(#paint8_linear)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 77.0164,
    y: 17.0913,
    width: 20.6093,
    height: 4.89935,
    rx: 2.44967,
    transform: "rotate(-45 77.0164 17.0913)",
    fill: "url(#paint9_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 18.5906,
    y: 32.8496,
    width: 59.6363,
    height: 27.8035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.615686 0 0 0 0 0.67451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 53.7612,
    y: 37.0903,
    width: 48.7389,
    height: 48.7389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 67.1403,
    y1: 6.67293,
    x2: 36.4959,
    y2: 65.3961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.275838,
    stopColor: "#D9FBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9FBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 55.0264,
    y1: 69.2706,
    x2: 85.1779,
    y2: 68.3085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00778F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009DAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 81.191,
    y1: 82.3835,
    x2: 98.1855,
    y2: 81.8412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00778F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009DAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 79.8487,
    y1: 70.9811,
    x2: 86.7013,
    y2: 70.7624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00778F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009DAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 0.189796,
    y1: 83.1616,
    x2: 16.7635,
    y2: 83.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.127403,
    stopColor: "#00E3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3D4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: -1.00206,
    y1: 56.4985,
    x2: 5.62418,
    y2: 56.4985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.127403,
    stopColor: "#00E3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3D4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: -2.69237,
    y1: 68.6855,
    x2: 32.6777,
    y2: 68.6855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.127403,
    stopColor: "#00E3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3D4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 65.2841,
    y1: 39.269,
    x2: 88.6814,
    y2: 39.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#00E3D4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 70.6891,
    y1: 7.55565,
    x2: 77.3153,
    y2: 7.55565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#00E3D4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 72.5527,
    y1: 19.7431,
    x2: 92.2437,
    y2: 19.7431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#00E3D4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateNotFound);
export default __webpack_public_path__ + "static/media/certificate_not_found.ff40163d680d5aac9355bc5309340e55.svg";
export { ForwardRef as ReactComponent };